"use client";

import { useEffect } from "react";
import rollbar from "@/instrumentation-client";

// FOUNDER-QA-FOLLOWUP-20260918-008/009 — root had NO global-error.tsx. `instrumentation.ts`'s
// `onRequestError` covers server-thrown errors, but a client-render exception inside RootLayout
// itself (the one place `instrumentation.ts` cannot see) went unreported — this app has no other
// error boundary above `layout.tsx`. Modeled on apps/accounts/src/app/global-error.tsx; root has no
// i18n routing, so `lang="en"` is hardcoded rather than read from an I18nRouting default.
export default function GlobalError(props: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    rollbar.error(props.error);
  }, [props.error]);

  return (
    <html lang="en">
      <body>
        <div style={{ padding: "2rem", textAlign: "center", fontFamily: "system-ui, sans-serif" }}>
          <h1>Something went wrong!</h1>
          <p>We apologize for the inconvenience. Please try again.</p>
          {props.error?.digest && (
            <p style={{ fontSize: "0.875rem", color: "#666" }}>Error ID: {props.error.digest}</p>
          )}
          <button
            type="button"
            onClick={() => props.reset()}
            style={{
              marginTop: "1rem",
              padding: "0.5rem 1rem",
              background: "#0070f3",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
